// tslint:disable:max-line-length

import React from 'react';

export const ChartBar = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <rect y="15" width="16" height="1" />
      <rect y="6" width="4" height="8" />
      <rect x="6" width="4" height="14" />
      <rect x="12" y="3" width="4" height="11" />
    </svg>
  );
};
